import React, { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Component that dynamically updates the favicon based on settings
 * Uses the same logo URL from settings as the main logo component
 */
const DynamicFavicon = () => {
  const [faviconUrl, setFaviconUrl] = useState('/assets/logo/logo.png');
  
  useEffect(() => {
    // Function to update favicon link element
    const updateFavicon = (url) => {
      // Find existing favicon or create new one
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      
      // Set the href attribute to the new URL
      link.href = url;
    };
    
    // Fetch logo from settings
    const fetchLogo = async () => {
      try {
        const response = await axios.get('/api/settings');
        if (response.data && response.data.logo) {
          setFaviconUrl(response.data.logo);
          updateFavicon(response.data.logo);
        }
      } catch (error) {
        console.error('Error fetching logo for favicon:', error);
        // Use default favicon if API call fails
        updateFavicon('/assets/logo/logo.png');
      }
    };
    
    fetchLogo();
    
    // Listen for logo updates
    const handleLogoUpdate = (event) => {
      if (event.detail && event.detail.logo) {
        setFaviconUrl(event.detail.logo);
        updateFavicon(event.detail.logo);
      }
    };
    
    window.addEventListener('logoUpdated', handleLogoUpdate);
    
    return () => {
      window.removeEventListener('logoUpdated', handleLogoUpdate);
    };
  }, []);
  
  // This component doesn't render anything visible
  return null;
};

export default DynamicFavicon;
